module.exports = __webpack_public_path__ + "fonts/d7fafde.ttf";